
import {
  SET_ONLINEACCESS,
  CREATE_ONLINEACCESS,
  ONLINEACCESSS_RECEIVED,
  SET_PROPERTY_ONLINEACCESS,
} from "../types/online_accesses";

const schema = {

}

const OnlineAccessesReducer = (state, { type, payload }) => {
  switch (type) {
    case ONLINEACCESSS_RECEIVED:
      return { ...state, online_accesses: payload };
    case SET_ONLINEACCESS:
      return { ...state, online_access: payload };
    case CREATE_ONLINEACCESS:
      return { ...state, online_access: schema };
    case SET_PROPERTY_ONLINEACCESS: {
      const { key, value } = payload;
      const online_access = { ...state.online_access };
      online_access[key] = value;
      return { ...state, online_access };
    }
    default:
      return { ...state};
  }
};

export default OnlineAccessesReducer;
